let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fdpGn")).then(() => parcelRequire('cUYyM'));